const variantMap = {
    outline: 'neutral-outline',
    solid: 'primary',
    link: 'link'
};
export const getButtonVariant = (variant)=>variant ? variantMap[variant] : undefined;

//# sourceMappingURL=button.js.map